import { Suspense } from 'react'

import Loader from './Loader'

const Loadable =
    (Component) =>
    // eslint-disable-next-line react/display-name
    ({ ...properties }) => {
        return (
            <Suspense fallback={<Loader />}>
                <Component {...properties} />
            </Suspense>
        )
    }

export default Loadable
